export default function getSiteUrlWithoutProtocol(url?: string | null) {
  if (typeof url !== 'string') return url;
  return url.replace(/^(https?:\/\/)/, '');
}
